import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Laboratory, Layout, OurTeam, ResearchLines, CursosSection,  ContactUs } from "./pages";
import ScrollToTop from "./components/ScrollToTop";
import EventsPage from "./pages/events/page";
import PublicationsPage from './pages/publications/page';
import MayanOnChipPage from "./pages/mayanOnChip/page";

export default function LabRoutes() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Laboratory/>} />
          <Route path="/ourTeam" element={<OurTeam/>} />
          <Route path="/researchLines" element={<ResearchLines/>} />
          <Route path="/publications" element={<PublicationsPage/>} />
          <Route path="/mayanOnChip" element={<MayanOnChipPage/>} />
          <Route path="/contactUs" element={<ContactUs/>} />
          <Route path="/" element={<CursosSection/>} />
          <Route path="/events" element={<EventsPage/>} />
        </Route>
      </Routes>
    </Router>
  );
}
